var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0 vh-100"},[_c('div',{staticClass:"row m-0 h-100"},[_c('div',{staticClass:"col"},[_c('MotorS',{attrs:{"cp":this.$route,"childrens":this.$route.meta.childrens,"idTela":this.idTela}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }